"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.LinkIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _link = require("./link.styles");

var _jsxRuntime = require("react/jsx-runtime");

const LinkIcon = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_link.StyledLinkIcon, {
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    shapeRendering: "geometricPrecision",
    className: "nextui-link-icon",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M15 3h6v6"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M10 14L21 3"
    })]
  });
};

exports.LinkIcon = LinkIcon;

LinkIcon.toString = () => '.nextui-link-icon';

var _default = /*#__PURE__*/_react.default.memo(LinkIcon);

exports.default = _default;